import React, { Component } from 'react';
import { connect }          from 'react-redux';
import {Link}               from 'react-router-dom'



class Equipes_item extends Component {

    render() {
        const dados = this.props.dados;
        const classStatus = (dados.equ_flag_ativo === 1 ? "communication-card-footer-label communication-card-footer-label-active" : "communication-card-footer-label");
        const status = (dados.equ_flag_ativo === 1 ? "Ativo" : "Inativo");
   
        return (

            		<Link to={`${this.props.menu.comunicacao.equipe}/${dados.equ_id}`} className="communication-card  communication-card-active">
						<div className="communication-card-body">
							<div className="communication-card-body-thumb">
							</div>
							<div className="communication-card-body-text">
                              {dados.equ_nome}
							</div>
						</div>
						<div className="communication-card-footer">
							<div className={classStatus}>
                                {status} 				
                        	</div>
							<div className="communication-card-footer-text">
                               {dados.dis_nome}
							</div>
						</div>
					</Link>
        );
        	
    }
}
function mapStateToProps(state){

    return { menu : state.configReducer.menu};
}

export default connect(mapStateToProps,{})(Equipes_item);




// WEBPACK FOOTER //
// ./src/components/aluno/comunicacao/equipe/equipes_item.js